import React from "react";
import { Card } from "./ui/Card";
import { Icon } from "./ui/Icon";
import { plan2plateIcons } from "../utils/iconUtils";
import { getDepartmentIcon } from "../data/department";
import { SectionLabel } from "./ui/SectionLabel";
import { SmallIconButton } from "./SmallIconButton";

export type AvailabilitySummaryEntry = {
  shopName: string;
  department?: { name: string; description: string };
};

export function AvailabilityCard({
  entries,
  onClick,
  editDataCy = "edit-pencil-button",
}: {
  entries: AvailabilitySummaryEntry[];
  onClick: () => void;
  editDataCy?: string;
}) {
  const icon = entries.length > 0 ? "pencil" : "shopCart";
  return (
    <Card className="flex flex-col gap-2 p-4 cursor-pointer hover:bg-surface-card/60 transition border-line bg-surface-card">
      <div className="flex items-center justify-between">
        <SectionLabel>Verfügbarkeit</SectionLabel>
        <SmallIconButton
          label="Verfügbarkeit bearbeiten"
          data-cy={editDataCy}
          icon={icon}
          onClick={onClick}
        />
      </div>

      {entries.length > 0 ? (
        <div className="flex flex-wrap gap-2 items-center mt-1">
          {entries.map((entry, idx) => (
            <span
              key={idx}
              className="pr-3 pl-2 py-1 rounded-full text-xs font-semibold border border-teal/20 flex items-center gap-1.5"
              title={entry.department?.description}
            >
              {entry.department && (
                <Icon size={28} className="shrink-0">
                  {plan2plateIcons[getDepartmentIcon(entry.department.name)]}
                </Icon>
              )}
              {entry.shopName}
            </span>
          ))}
        </div>
      ) : (
        <span className="text-sm text-ink-muted italic mt-1">
          Keine Verfügbarkeiten definiert
        </span>
      )}
    </Card>
  );
}
